import DescriptionOutlinedIcon from '@mui/icons-material/DescriptionOutlined';
import {
  BulkManagementIcon,
  DashboardIcon,
  HeartbeatIcon,
  OrganizationWorkerIcon,
} from '@stack/assets/icons';
import { hasPermissions } from '@stack/components/components/AuthView';
import { VerticalNavItemsType } from '@webbyx/mui';
import { useAuthIdentity } from '@webbyx/next-js';
import useTranslation from 'next-translate/useTranslation';

/**
 * ===========================
 * MAIN
 * ===========================
 */
export const useNavigationItems = (): VerticalNavItemsType[] => {
  // ================== HOOKS
  const { authUser } = useAuthIdentity();
  const { t } = useTranslation('common');
  return [
    {
      key: 'dashboard',
      title: t('common:dashboard'),
      icon: <DashboardIcon />,
      authorization: hasPermissions(['clinic_dashboard']),
      path: '/dashboard',
    },
    {
      key: 'check-in-session',
      title: t('common:check-in-session'),
      icon: <HeartbeatIcon />,
      path: '/session',
      authorization: hasPermissions([
        'clinic_checkin_listing',
        'clinic_checkin_manage',
      ]),
      includes: ['/session/new-session', '/session/check-out/[id]'],
      badge: authUser?.clinic?.ongoing_session_count,
    },
    {
      type: 'group',
      key: 'admin',
      title: t('common:admin'),
      icon: <OrganizationWorkerIcon />,
      authorization: hasPermissions([
        'clinic_admin_listing',
        'clinic_admin_manage',
      ]),
      children: [
        {
          type: 'item',
          key: 'admin-listing',
          title: t('common:admin-listing'),
          path: '/admin',
          authorization: hasPermissions([
            'clinic_admin_listing',
            'clinic_admin_manage',
          ]),
          includes: ['/admin/new', '/admin/[id]/edit', '/admin/[id]'],
        },
        {
          type: 'item',
          key: 'admin-role',
          title: t('common:admin-role'),
          path: '/admin/role',
          authorization: hasPermissions([
            'clinic_admin_listing',
            'clinic_admin_manage',
          ]),
          includes: ['/admin/role/new', '/admin/role/[id]/edit'],
        },
      ],
    },
    {
      key: 'report',
      title: t('common:report'),
      icon: <DescriptionOutlinedIcon />,
      path: '/report',
      authorization: hasPermissions(['clinic_report']),
    },
    {
      key: 'bulk-management',
      title: 'Bulk Management',
      icon: <BulkManagementIcon />,
      path: '/bulk-management',
    },
  ];
};

/**
 * ===========================
 * EXPORTS
 * ===========================
 */
export default useNavigationItems;
